import { router } from "@/routes";
import { useConfigStore } from "@/store/config";
import { setGlobalMessage } from "@/utils/notificationManager";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as Antd, ConfigProvider, theme as antdTheme } from "antd";
import en from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import { useEffect } from "react";
import { RouterProvider } from "react-router";
import { type FC } from "react";
const MessageInitializer: FC = () => {
  const { message } = Antd.useApp();
  useEffect(() => {
    setGlobalMessage(message);
  }, [message]);
  return null;
};
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
export default function App() {
  const { theme, locale } = useConfigStore();
  return (
    <QueryClientProvider client={queryClient}>
      <Antd>
        <ConfigProvider
          locale={locale === "zh-CN" ? zhCN : en}
          theme={{
            algorithm:
              theme === "dark"
                ? antdTheme.darkAlgorithm
                : antdTheme.defaultAlgorithm,
            token: {
              colorPrimary: "#2563eb",
              colorInfo: "#2563eb",
              colorSuccess: "#16a34a",
              colorWarning: "#d97706",
              colorError: "#dc2626",
              borderRadius: 12,
            },
            components: {
              Layout: {
                headerBg: theme === "dark" ? "#020617cc" : "#ffffffd9",
              },
              Card: {
                borderRadiusLG: 16,
              },
              Button: {
                borderRadius: 10,
              },
            },
          }}
        >
          <RouterProvider router={router} />
          <MessageInitializer />
        </ConfigProvider>
      </Antd>
    </QueryClientProvider>
  );
}
